import { render, staticRenderFns } from "./hqnotice.vue?vue&type=template&id=3a5afdd6&scoped=true"
import script from "./hqnotice.vue?vue&type=script&lang=js"
export * from "./hqnotice.vue?vue&type=script&lang=js"
import style0 from "./hqnotice.vue?vue&type=style&index=0&id=3a5afdd6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5afdd6",
  null
  
)

export default component.exports